import React, { useState } from "react";
// reactstrap components
import {
    FormGroup,
    Label,
    Button,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
import Datetime from 'react-datetime';
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSUpload from "components/Forms/TSUpload2.js";
import TSText from "components/Forms/TSText.js";

import { useDropzone } from 'react-dropzone'
import 'assets/css/react-datetime.css'

import Resizer from 'react-image-file-resizer';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

//function TelePage2() {
const ConfirmPayment = (props) => {
    const teleID = (props.match.params.teleID !== undefined) ? props.match.params.teleID : null;

    const [dateFocus, setDateFocus] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [ServiceType, setType] = useState("");
    const [AppointDatetime, setDate] = useState("");
    const [Phone, setPhone] = useState("");
    const [LineID, setLine] = useState("");
    const [ShippingAddress, setAddress] = useState("");
    const [Description, setDescription] = useState("");
    const [Id, setId] = useState("");
    const [FileData, setFileData] = useState("");
    const [files, setFiles] = useState([]);
    const [theArray, setTheArray] = useState([]);

    const currentUser = authenticationService.currentUserValue;

    const liff = window.liff;
        liff.init({
            liffId: '1654063801-JpnXVx2a'
        })
       .then(() => {
           /*
            if (liff.isLoggedIn()) {
                liff.getProfile().then(function (profile) {
                    alert(profile.userId)

                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                                //this.props.history.push(from);
                                //window.alert(user)
                            },
                            error => {
                                console.log(error);
                            }
                    );


                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });
                
            }
            */
        })
        .catch((err) => {

        });

        React.useEffect(() => {
            if (!currentUser) {
                window.location.assign('/login');
            }

            setLine(currentUser.fullName)

            fetch('/api/v1/mytele/' + teleID, {
                    method: 'GET',
                    headers: authHeader()
            })
                .then(handleResponse)
                //.then(response => response.json())
                .then(
                    (result) => {
                            setId(result.data.teleID)
                    },
                    (error) => {
                            alert(error);
                    }
                );

        }, []);

    var fileTxt = "";

    var moment = require('moment');
    require('moment/locale/th');

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ));
        }
    });

    async function uploadWithJSON2(file) {
        const resizeImg = file => new Promise((resolve, reject) => {
            var canvas = document.getElementById("canvas");
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;

            // limit the image to 150x100 maximum size
            var maxW = 800;
            var maxH = 600;

            var img = new Image;
            img.src = URL.createObjectURL(file);

            var result = "";
            img.onload = function () {
                var iw = img.width;
                var ih = img.height;
                var scale = Math.min((maxW / iw), (maxH / ih));
                var iwScaled = iw * scale;
                var ihScaled = ih * scale;
                canvas.width = iwScaled;
                canvas.height = ihScaled;
                ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
                result = canvas.toDataURL();
                resolve(result)
            }
            img.onerror = error => reject(error);

            return result;
        });

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await resizeImg(file),
        }

        return await data;
    }

    async function uploadWithJSON(file) {
        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }); 

        const toBase64Resize = (file2) => new Promise(resolve => {
            var compressType;

            if (file2.type == 'image/jpeg')
                compressType = 'JPEG';
            else if (file2.type == 'image/png')
                compressType = 'PNG';
            else if (file2.type == 'image/webp')
                compressType = 'WEBP';

            Resizer.imageFileResizer(file2, 1000, 1000, compressType, 100, 0,
                uri => {
                    resolve(uri);
                },
                'base64'
            );
        });

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await toBase64Resize(file),
            //fileBase64: await toBase64(file),
        }

        return await data;
    }

    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                />
            </div>
        </div>
    ));

    const handleSubmit = (evt) => {
        evt.preventDefault();

        var cntErr = 0;
        var errMsg = '';


        if (files == null || files.length < 1) {
            cntErr += 1;
            errMsg = 'กรุณาแนบรูปหลักฐานการชำระเงิน';
        }

  
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModal2(true);
        }     
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


        //alert(`Submitting Type ${ServiceType} Date ${AppointDatetime} LineID ${LineID}, Phone ${Phone}, ShippingAddress ${ShippingAddress}, Description ${Description} `)

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "flowStatus": 4,
            })
        };
        //alert(authenticationService.currentUserValue.token)
        //fetch('/api/v1/tele/' + Id, requestOptions)
        fetch('/api/v1/tele/transfer/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    //alert(result.data.teleID);
                    var totalFile = files.length;
                    if (totalFile > 0) {
                        files.map((file, index) => {
                            const prom = uploadWithJSON(file);
                            Promise.resolve(prom).then((e) => {

                                const reqOpt = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json-patch+json',
                                        'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                                    },
                                    body: JSON.stringify({
                                        "teleID": result.data.teleID,
                                        "fileName": e.fileName,
                                        "fileCategoryID": 2,
                                        "fileType": e.fileType,
                                        "fileSize": e.fileSize,
                                        "fileBase64": e.fileBase64,
                                    })
                                };
                                
                                fetch('/api/v1/tele/upload', reqOpt)
                                    .then(handleResponse)
                                    .then(
                                        (result) => {
                                            //console.log(result);
                                            //alert(result.data.fileID)
                                            if (index == (totalFile - 1)) {
                                                if (liff.isInClient()) {

                                                    liff.sendMessages([{
                                                        'type': 'text',
                                                        'text': '#ยืนยันการชำระเงิน'
                                                    }]).then(function () {
                                                        liff.closeWindow();
                                                    }).catch(function (error) {
                                                        window.alert('ยืนยันการชำระเงินเรียบร้อยแล้ว');
                                                        liff.closeWindow();
                                                        //window.alert('Error sending message: ' + error);
                                                    });


                                                } else {
                                                    const { from } = props.location.state || { from: { pathname: "/home" } };
                                                    props.history.push(from);
                                                }
                                            }
                                            
                                        },
                                        (error) => {
                                            console.log(error);
                                            alert('upload error ' + error)
                                        }
                                    )
                                
                            });
                        });
                    }
                    else
                    {
                            if (liff.isInClient()) {
                                liff.sendMessages([{
                                    'type': 'text',
                                    'text': '#ยืนยันการชำระเงิน'
                                }]).then(function () {
                                    liff.closeWindow();
                                }).catch(function (error) {
                                    window.alert('ยืนยันการชำระเงินเรียบร้อยแล้ว');
                                    liff.closeWindow();
                                    //window.alert('Error sending message: ' + error);
                                });
                            } else {
                                const { from } = props.location.state || { from: { pathname: "/home" } };
                                props.history.push(from);
                            }
                    }
                    //setId(result.data.teleID);
                    //setModal2(true);

                    //bug อยู่  ต้องรอให้ upload เสร็จก่อน ถึงจะปิดจอ
                    /*
                    if (liff.isInClient()) {

                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#ยืนยันการจอง'
                        }]).then(function () {
                            //window.alert('Message sent');
                        }).catch(function (error) {
                            window.alert('Error sending message: ' + error);
                        });

                        //liff.closeWindow();
                    } else {
                        const { from } = props.location.state || { from: { pathname: "/home" } };
                        props.history.push(from);
                    }
                    */
                },
                (error) => {
                    alert('update error' + error);
                }
            )  
    }


  return (
    <>
      <div className="wrapper">
        <div className="section section-contact-us" style={{paddingTop:'10px'}}>
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto" lg="6" md="8">
                              {/*{LineID} {Id} */}
                        <section className="container text-center" style={{cursor: 'pointer', border: '1px dashed', padding: '20px 0px'}}>
                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input name="fileUpload" {...getInputProps()} /*onChange={handleChange}*/ />
                                <p> <i className="now-ui-icons design_image"></i> แนบไฟล์รูปภาพหลักฐานการชำระเงิน </p>
                            </div>
                            <aside style={thumbsContainer}>
                                {thumbs}
                            </aside>
                        </section>

                        <div className="send-button">
                            <Button
                                block
                                className="btn-round"
                                color="info"
                                href="#"
                                size="lg"
                                style={{ fontSize: '1.2em' }}
                                onClick={handleSubmit}
                            >
                                      ยืนยันการชำระเงิน
                            </Button>

                            {/* Confirm */}
                            <Modal
                                modalClassName="modal-mini modal-info"
                                toggle={() => setModal2(false)}
                                isOpen={modal2}
                            >
                                <div className="modal-header justify-content-center">
                                    <div className="modal-profile">
                                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                    </div>
                                </div>
                                <ModalBody>

                                          <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังบันทึกข้อมูล"}</p>
                                          <p>  </p>
                                      </ModalBody>
                                <div className="modal-footer">
                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={() => setModal2(false)}
                                          >
                                              ยกเลิก
                                      </Button>

                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={handleConfirm}
                                              disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                          //onClick={() => setModal2(false)}
                                          >
                                              ยืนยัน
                                          </Button>
                                      </div>
                            </Modal>

                            {/* Error */}
                            <Modal
                                      modalClassName="modal-mini modal-danger"
                                      toggle={() => setModalError(false)}
                                      isOpen={modalError}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                          <p> {errMsg} </p>
                                      </ModalBody>
                                      <div className="modal-footer justify-content-center">
                                          <Button
                                              className="btn-neutral"
                                              color="neutral"
                                              type="button"
                                              onClick={() => setModalError(false)}
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>

                              </div>

                    </Col>

                </Row>
                </Container>
                  <canvas id="canvas" style={{display:'none'}} width="300" height="300"></canvas>
        </div>
    
      </div>
    </>
  );
}

export default ConfirmPayment;
